import { LoyaltyHomeBody } from './LoyaltyHomeBody';
import { LoyaltyHomeChallenges } from './LoyaltyHomeChallenges';
import { LoyaltyHomeChallengesEmptyState } from './LoyaltyHomeChallengesEmptyState';
import { LoyaltyHomeChallengesRewardsContainer } from './LoyaltyHomeChallengesRewardsContainer';
import { LoyaltyHomeContainer } from './LoyaltyHomeContainer';
import { LoyaltyHomeErrorState } from './LoyaltyHomeErrorState';
import { LoyaltyHomeFooter } from './LoyaltyHomeFooter';
import { LoyaltyHomeHeader } from './LoyaltyHomeHeader';
import { LoyaltyHomeHowItWorks } from './LoyaltyHomeHowItWorks';
import { LoyaltyHomeLegalDisclaimer } from './LoyaltyHomeLegalDisclaimer';
import { LoyaltyHomeProgressBenefit } from './LoyaltyHomeProgressBenefit';
import { LoyaltyHomeRewards } from './LoyaltyHomeRewards';
import { LoyaltyHomeRewardsEmptyState } from './LoyaltyHomeRewardsEmptyState';
import { LoyaltyHomeRewardsGrid } from './LoyaltyHomeRewardsGrid';
import { LoyaltyHomeScanButton } from './LoyaltyHomeScanButton';
import { LoyaltyHomeUnlockableRewards } from './LoyaltyHomeUnlockableRewards';

export const LoyaltyHome = {
  Container: LoyaltyHomeContainer,
  ChallengeRewardsContainer: LoyaltyHomeChallengesRewardsContainer,
  Header: LoyaltyHomeHeader,
  Body: LoyaltyHomeBody,
  ProgressBenefit: LoyaltyHomeProgressBenefit,
  Footer: LoyaltyHomeFooter,
  Challenges: LoyaltyHomeChallenges,
  ChallengesEmptyState: LoyaltyHomeChallengesEmptyState,
  Rewards: LoyaltyHomeRewards,
  RewardsEmptyState: LoyaltyHomeRewardsEmptyState,
  RewardsGrid: LoyaltyHomeRewardsGrid,
  UnlockableRewards: LoyaltyHomeUnlockableRewards,
  HowItWorks: LoyaltyHomeHowItWorks,
  ScanButton: LoyaltyHomeScanButton,
  ErrorState: LoyaltyHomeErrorState,
  LegalDisclaimer: LoyaltyHomeLegalDisclaimer,
};
